// extracted by mini-css-extract-plugin
module.exports = {"chip":"chip-1Q8UJ","close":"close-8XwM2"};